module.exports = __webpack_public_path__ + "img/lamont-mothlabani.741af7fa.png";